(function () {
    'use strict';

    angular
        .module('app.associationAdmin')
        .config(configRoutes);

    configRoutes.$inject = ['$stateProvider', 'transfersResolver', 'associationReportsResolver', 'associationClassicReportsResolver', 'associationMemberReportResolver', 'associationClubComplianceReportResolver', 'associationMemberComplianceReportResolver' ];
    function configRoutes($stateProvider, transfersResolver, associationReportsResolver, associationClassicReportsResolver, associationMemberReportResolver, associationClubComplianceReportResolver, associationMemberComplianceReportResolver) {
        $stateProvider
            .state('association-admin', {
                url: '/associations',
                component: 'sc3AssociationAdmin',
                data: {
                    requireAdmin: true
                },
                redirectTo: 'association-admin.search'
            })

            .state('association-admin.search', {
                url: '/search',
                component: 'sc3MemberLookup'
            })

           .state('association-admin.transfers', {
                url: '/transfers',
                component: 'sc3Transfers',
                resolve: transfersResolver
            })

            .state('association-admin.club-compliance-report', {
                url: '/clubComplianceReport',
                component: 'sc3AssociationClubComplianceReport',
                resolve: associationClubComplianceReportResolver
            })

              .state('association-admin.member-compliance-report', {
                url: '/memberComplianceReport',
                component: 'sc3AssociationMemberComplianceReport',
                resolve: associationMemberComplianceReportResolver
            })

            .state('association-admin.classic-reports', {
                url: '/classicReports',
                component: 'sc3AssociationClassicReports',
                resolve: associationClassicReportsResolver
            })

            .state('association-admin.member-report', {
                url: '/memberReport',
                component: 'sc3AssociationMemberReport',
                resolve: associationMemberReportResolver
            })

             
    }
})();